import { render, staticRenderFns } from "./let-your-boat.vue?vue&type=template&id=8c6d3a02&scoped=true"
import script from "./let-your-boat.vue?vue&type=script&lang=js"
export * from "./let-your-boat.vue?vue&type=script&lang=js"
import style0 from "./let-your-boat.vue?vue&type=style&index=0&id=8c6d3a02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6d3a02",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default,VBreadcrumbs: require('/var/www/tubber-new/components/global/v/breadcrumbs.vue').default,VIcon: require('/var/www/tubber-new/components/global/v/icon.vue').default,ContactUsCard: require('/var/www/tubber-new/components/global/ContactUsCard.vue').default})
